var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editor",staticClass:"editable-el",class:{
      'edit-un-submit': _vm.isEdited,
    },attrs:{"contenteditable":"true"},on:{"blur":function($event){return _vm.handleBlur($event)},"focus":_vm.handleFocus}})])
}
var staticRenderFns = []

export { render, staticRenderFns }